import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

export default () => (
  <StaticQuery
    query={graphql`{
  logo: file(relativePath: {eq: "images/logo.png"}) {
    childImageSharp {
      gatsbyImageData(width: 200, layout: CONSTRAINED)
    }
  }
}`}
    render={data => <GatsbyImage image={data.logo.childImageSharp.gatsbyImageData} />}
  />
)
